var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bg-FF" }, [
    _c(
      "div",
      { staticClass: "b-r-10 m-10" },
      [
        _c(
          "van-form",
          {
            attrs: { "show-error": false, "error-message-align": "right" },
            on: { submit: _vm.onSubmit },
          },
          [
            _c("van-field", {
              attrs: {
                "input-align": "right",
                label: "记录人",
                value: _vm.loginUser.nickName,
                readonly: "",
              },
            }),
            _c("van-field", {
              attrs: {
                "input-align": "right",
                label: "所属部门",
                autosize: "",
                type: "textarea",
                value: this.loginUser.deptNames[0],
                readonly: "",
              },
            }),
            _c("van-field", {
              attrs: {
                "input-align": "right",
                value: _vm.visitFormData.customerCompanyName,
                label: "所属客户",
                rules: [{ required: true, message: "请选择所属客户" }],
                placeholder: "请选择所属客户",
              },
              scopedSlots: _vm._u([
                {
                  key: "input",
                  fn: function () {
                    return [
                      _c("view-item", {
                        attrs: {
                          value: _vm.visitFormData.customerCompanyName,
                          placeholder: "请选择所属客户",
                        },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.isShowPopup(
                              _vm.companyName,
                              "companyName"
                            )
                          },
                        },
                      }),
                      _c(
                        "van-popup",
                        {
                          attrs: { position: "bottom" },
                          model: {
                            value: _vm.companyName.show,
                            callback: function ($$v) {
                              _vm.$set(_vm.companyName, "show", $$v)
                            },
                            expression: "companyName.show",
                          },
                        },
                        [
                          _c("van-nav-bar", {
                            attrs: {
                              title: "所属客户",
                              "left-text": "取消",
                              "right-text": "确定",
                            },
                            on: {
                              "click-left": function ($event) {
                                _vm.companyName.show = false
                              },
                              "click-right": _vm.sskhConfirm,
                            },
                          }),
                          _c("van-search", {
                            attrs: {
                              "show-action": "",
                              clearable: "",
                              shape: "round",
                            },
                            on: { search: _vm.pickerSearchCompany },
                            scopedSlots: _vm._u([
                              {
                                key: "action",
                                fn: function () {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        on: { click: _vm.pickerSearchCompany },
                                      },
                                      [_vm._v("搜索")]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.companyName.filterText,
                              callback: function ($$v) {
                                _vm.$set(_vm.companyName, "filterText", $$v)
                              },
                              expression: "companyName.filterText",
                            },
                          }),
                          _c("van-picker", {
                            ref: "companyName",
                            attrs: {
                              "value-key": "companyName",
                              columns: _vm.companyName.filteredData,
                            },
                            on: {
                              cancel: function ($event) {
                                _vm.companyName.show = false
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _c("van-field", {
              attrs: {
                "input-align": "right",
                readonly: _vm.isEdit,
                rows: "2",
                autosize: "",
                label: "客户地址",
                type: "textarea",
                maxlength: "140",
                placeholder: "请输入客户地址",
                "show-word-limit": "",
              },
              model: {
                value: _vm.visitFormData.customerCompanyPlace,
                callback: function ($$v) {
                  _vm.$set(_vm.visitFormData, "customerCompanyPlace", $$v)
                },
                expression: "visitFormData.customerCompanyPlace",
              },
            }),
            _c(
              "van-popup",
              {
                attrs: { position: "bottom" },
                model: {
                  value: _vm.showLocationPicker,
                  callback: function ($$v) {
                    _vm.showLocationPicker = $$v
                  },
                  expression: "showLocationPicker",
                },
              },
              [
                _c("van-picker", {
                  attrs: { "show-toolbar": "", columns: _vm.locationColumns },
                  on: {
                    confirm: _vm.onLocationConfirm,
                    cancel: function ($event) {
                      _vm.showLocationPicker = false
                    },
                  },
                }),
              ],
              1
            ),
            _c("van-field", {
              attrs: {
                "input-align": "right",
                clickable: "",
                required: "",
                rules: [{ required: true, message: "请选择拜访日期" }],
                value: _vm.visitFormData.visitTime,
                readonly: "",
                label: "拜访日期",
                placeholder: "点击拜访日期",
              },
              on: {
                click: function ($event) {
                  _vm.dateTimeShow = true
                },
              },
            }),
            _c(
              "van-popup",
              {
                attrs: { position: "bottom" },
                model: {
                  value: _vm.dateTimeShow,
                  callback: function ($$v) {
                    _vm.dateTimeShow = $$v
                  },
                  expression: "dateTimeShow",
                },
              },
              [
                _c("van-datetime-picker", {
                  attrs: { type: "datetime", title: "选择完整时间" },
                  on: {
                    cancel: function ($event) {
                      _vm.dateTimeShow = false
                    },
                    confirm: _vm.dateTimeConfirm,
                  },
                  model: {
                    value: _vm.visitFormData.visitDateTime,
                    callback: function ($$v) {
                      _vm.$set(_vm.visitFormData, "visitDateTime", $$v)
                    },
                    expression: "visitFormData.visitDateTime",
                  },
                }),
              ],
              1
            ),
            _c("van-field", {
              attrs: {
                "input-align": "right",
                readonly: "",
                clickable: "",
                required: "",
                name: "dictLabel",
                value: _vm.visitFormData.visitTypeName,
                label: "拜访方式",
                placeholder: "请选择拜访方式",
                rules: [{ required: true, message: "请选择拜访方式" }],
              },
              on: {
                click: function ($event) {
                  _vm.pickerShow = true
                },
              },
            }),
            _c(
              "van-popup",
              {
                attrs: { position: "bottom" },
                model: {
                  value: _vm.pickerShow,
                  callback: function ($$v) {
                    _vm.pickerShow = $$v
                  },
                  expression: "pickerShow",
                },
              },
              [
                _c("van-picker", {
                  attrs: {
                    "show-toolbar": "",
                    columns: _vm.visitDictData,
                    "value-key": "dictLabel",
                  },
                  on: {
                    confirm: _vm.pickerConfirm,
                    cancel: function ($event) {
                      _vm.pickerShow = false
                    },
                  },
                }),
              ],
              1
            ),
            _c("van-field", {
              attrs: {
                "input-align": "right",
                readonly: "",
                clickable: "",
                required: "",
                name: "picker",
                value: _vm.visitFormData.customerUserName,
                label: "拜访人",
                placeholder: "请选择拜访人",
                rules: [{ required: true, message: "请选择拜访人" }],
              },
              on: {
                click: function ($event) {
                  return _vm.getCustomerUser(_vm.companyId)
                },
              },
            }),
            _c(
              "van-popup",
              {
                attrs: { position: "bottom" },
                model: {
                  value: _vm.userShow,
                  callback: function ($$v) {
                    _vm.userShow = $$v
                  },
                  expression: "userShow",
                },
              },
              [
                _c("van-picker", {
                  attrs: {
                    "show-toolbar": "",
                    columns: _vm.customerUserList,
                    show: _vm.userShow,
                    "value-key": "userName",
                  },
                  on: {
                    confirm: _vm.userConfirm,
                    cancel: function ($event) {
                      _vm.userShow = false
                    },
                  },
                }),
              ],
              1
            ),
            _vm.visitFormData.visitType == "0"
              ? _c("van-field", {
                  attrs: {
                    "input-align": "right",
                    label: "拜访时长",
                    placeholder: "请输入拜访时长",
                  },
                  on: { change: _vm.buildVisitRecord },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "right-icon",
                        fn: function () {
                          return [
                            _c("span", { staticClass: "row-name" }, [
                              _vm._v(" 小时 "),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    3283552031
                  ),
                  model: {
                    value: _vm.visitFormData.visitDuration,
                    callback: function ($$v) {
                      _vm.$set(_vm.visitFormData, "visitDuration", $$v)
                    },
                    expression: "visitFormData.visitDuration",
                  },
                })
              : _vm._e(),
            _c("van-field", {
              attrs: {
                "input-align": "right",
                label: "随行人员",
                placeholder: "请输入随行人员",
              },
              on: { change: _vm.buildVisitRecord },
              model: {
                value: _vm.visitFormData.visitEntourage,
                callback: function ($$v) {
                  _vm.$set(_vm.visitFormData, "visitEntourage", $$v)
                },
                expression: "visitFormData.visitEntourage",
              },
            }),
            _c("van-field", {
              attrs: {
                "input-align": "right",
                rows: "2",
                autosize: "",
                label: "拜访记录",
                type: "textarea",
                maxlength: "140",
                placeholder: "请输入拜访记录",
                "show-word-limit": "",
              },
              model: {
                value: _vm.visitFormData.visitGoal,
                callback: function ($$v) {
                  _vm.$set(_vm.visitFormData, "visitGoal", $$v)
                },
                expression: "visitFormData.visitGoal",
              },
            }),
            _c("van-field", {
              staticClass: "noAfterBorder fileValueBox",
              attrs: {
                "input-align": "right",
                name: "fj",
                label: "附件",
                placeholder: "请上传文件",
              },
              domProps: { value: _vm.visitFormData.fileList },
              scopedSlots: _vm._u([
                {
                  key: "input",
                  fn: function () {
                    return [
                      _c("uploadFiles", {
                        attrs: {
                          files: _vm.visitFormData.fileList,
                          moduleType: "visit",
                        },
                        on: {
                          success: _vm.uploadSuccess,
                          fileRemove: (removedFile) =>
                            _vm.handleFileRemove(
                              removedFile,
                              "visitFormData",
                              "fileList"
                            ),
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _c("div", { staticClass: "bottom-bar-placeholder" }, [
              _c("div", { staticClass: "bottom-bar flex" }, [
                _c(
                  "div",
                  {
                    staticClass: "btn-item flex-1 bg-FFDB43",
                    on: { click: _vm.onSubmit },
                  },
                  [_vm._v(" " + _vm._s("保存") + " ")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "btn-item flex-1 bg-FF",
                    on: { click: _vm.goBack },
                  },
                  [_vm._v(" " + _vm._s("取消") + " ")]
                ),
              ]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }